import ConfirmationButton from './ConfirmationButton'
export default ConfirmationButton